var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-scene" },
    [
      _c(
        "Container",
        {
          attrs: {
            orientation: "!horizontal",
            "drag-handle-selector": ".column-drag-handle",
            "drop-placeholder": _vm.upperDropPlaceholderOptions
          },
          on: { "drag-start": _vm.dragStart }
        },
        _vm._l(_vm.cardGrp, function(column) {
          return _c("Draggable", { key: column.id }, [
            _c(
              "div",
              { class: column.props.className },
              [
                _c(
                  "Container",
                  {
                    attrs: {
                      "group-name": "col",
                      "get-child-payload": _vm.getCardPayload(),
                      "drag-class": "card-ghost",
                      "drop-class": "card-ghost-drop",
                      "drop-placeholder": _vm.dropPlaceholderOptions
                    },
                    on: {
                      drop: function(e) {
                        return _vm.onCardDrop(column.id, e)
                      }
                    }
                  },
                  _vm._l(_vm.list, function(data, i) {
                    return _c("Draggable", { key: i }, [
                      _c(
                        "div",
                        { staticClass: "card" },
                        [_vm._t("card", null, { card: data, index: i })],
                        2
                      )
                    ])
                  }),
                  1
                )
              ],
              1
            )
          ])
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }